import {Component, OnInit} from '@angular/core';
import {AcabimAuthService} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-user-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

    protected name = 'PasswordComponent';

    constructor(private readonly acabimAuthService: AcabimAuthService) {
    }

    ngOnInit(): void {
        this.acabimAuthService.getUser().subscribe(user => {
            if (user) {
                const navigationDetails = `/auth/Account/ChangePassword?UserId=${user.id}&ClientId=acabim-spa-client&RedirectUrl=/user/profile`;
                const redirectUrl = `${window.location.origin}${navigationDetails}`;

                // We cannot use router redirects here since ChangePassword is not handled by an angular component
                window.location.replace(redirectUrl);
            } else {
                console.error('Unable to redirect to change password - No User Found');
            }
        });
    }
}
